import { Serializable } from './serializable';

export class Feature implements Serializable<Feature> {
  private _id: string = '';
  public evaluationUuid: string = '';
  public evaluationCode: string = '';
  public startDate: Date = null;
  public endDate: Date = null;
  public featureName: string = '';
  public featureValue: any = null;
  public featureUnit: string = '';
  public featureType: string = '';
  public featureMin: number = null;
  public featureMax: number = null;

  /**
   * Gets entity id
   * @returns entity id
   */
  getId(): string {
    return this._id;
  }

  /**
   * Transforms received object to Feature entity
   * @param input
   * @returns Feature entity
   */
  deserialize(input: any = {}): Feature {
    if (!input) {
      return null;
    }

    const properties = Object.getOwnPropertyNames(this);
    Object.keys(input).forEach((key) => {
      if (input[key] !== null) {
        switch (key) {
          case 'featureId':
            this._id = input[key];
            break;
          case 'startDate':
          case 'endDate':
            this[key] = new Date(input[key]);
            break;
          default:
            if (properties.includes(key)) {
              this[key] = input[key];
            }
            break;
        }
      }
    });

    return this;
  }

  /**
   * Transforms Feature entity to json object
   * @returns json object
   */
  public serialize(): any {
    const output = {};

    Object.getOwnPropertyNames(this).forEach((property) => {
      switch (property) {
        case '_id':
          if (this[property]) {
            output['featureId'] = this[property];
          }
          break;
        default:
          output[property] = this[property];
          break;
      }
    });

    return output;
  }
}
